import { AccountingRowReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the rows report builder for ad hoc accounting row based reports.
 * @example
 * ```html
 * <salaxy-accounting-row-report template-id="plain"></salaxy-accounting-row-report>
 * ```
 */
export class AccountingRowReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** Template for the report */
      templateId: "<",
    };

    /** Uses the AccountngRowReportController */
    public controller = AccountingRowReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/AccountingRowReport.html";

}
